// StoryCard molecule component
import { Card } from "./Card";

export const StoryCard = ({ story, onClick }) => {
  return (
    <Card
      hoverable
      className="overflow-hidden cursor-pointer"
      onClick={onClick}
    >
      <img
        src={story.img}
        alt={story.title}
        loading="lazy"
        decoding="async"
        width="400"
        height="256"
        className="w-full h-64 object-cover hover:scale-110 transition duration-500"
        onError={(e) => {
          e.target.src = "https://via.placeholder.com/400x300?text=Story+Image";
        }}
      />
      <div className="p-6">
        <h3 className="text-2xl font-semibold mb-3">{story.title}</h3>
        <p className="text-gray-600">{story.desc}</p>
      </div>
    </Card>
  );
};
